import { createFileRoute } from '@tanstack/react-router'
import VideoProcessingPage from '@/pages/(protected)/workspaces/[workspaceId]/video-processing'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/video-processing'
)({
  component: VideoProcessingPage,
}) 